/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Model_SystemPackageGet } from '../models/Model_SystemPackageGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemPackageService {
    /**
     * @returns Model_SystemPackageGet Success
     * @throws ApiError
     */
    public static getApiV1SystemPackage(): CancelablePromise<Array<Model_SystemPackageGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/systemPackage',
        });
    }
}
